module.exports = __webpack_public_path__ + "48cc6e87469b44e06181b50958f3f9c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/target_2022_chart.png
// module id = 1746
// module chunks = 0